module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-all-300-normal.woff?168d6383e73339293ac33d2726ba151e";